import "./Home.module.css";
import SiteHeader from "@/reusable_sections/Header";
import SpaceOfMeanings from "./sections/SpaceOfMeanings";
import ProfessionalProfile from "./sections/ProfessionalProfile";
import HowWeHelpYou from "./sections/HowWeHelpYou";
import PrinciplesOfDefense from "./sections/PrinciplesOfDefense";
import CalculationRequest from "./sections/CalculationRequest";
import WhereWeAreLocated from "./sections/WhereWeAreLocated";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <SiteHeader />
      <SpaceOfMeanings />
      <ProfessionalProfile />
      <HowWeHelpYou />
      <PrinciplesOfDefense />
      <CalculationRequest />
      <WhereWeAreLocated />
      <Footer />
    </div>;
}